/* 諸葛亮（字孔明） */
import { gd } from '../../core/kit.ts';
import { defineHero, P, D } from '../define.ts';

export default defineHero({
  id: 'zhugeliang', name: '諸葛亮', sub: '字孔明', faction: 'shu', role: '法師', weapon: 'fan',
  look: { head: 'lunjin', beard: 'goatee', eye: 'narrow', robe: true, fx: '#9fe7ff', c: { cloth: '#e6e2d6', sleeve: '#e6e2d6', armor: '#3e7b50', trim: '#3e7b50', hood: '#2a2f2a', belt: '#3e7b50', pants: '#3a3a3a' } },
  skills: [
    ['暴雷雨', 'thunder', '落雷轟擊 {2/3/4/5} 個敵人，各造成 {72/130/185/240} 傷害。', { x: { k: 'multi', dmg: [72, 130, 185, 240], n: [2, 3, 4, 5], r: 260, fx: 'thunder' }, aim: P(560, 200), cd: 14 }],
    ['極凍凝結', 'thunder', '凍結指定範圍，造成 {70/120/170/220} 傷害並凍結 2 秒。', { x: { k: 'aoe', dmg: [70, 120, 170, 220], r: [120, 136, 176, 176], cc: { freeze: 2 }, fx: 'ice' }, aim: P(416, [120, 136, 176, 176]), cd: 18 }],
    ['颶風', 'command', '召喚龍捲風 10 秒，每秒對周圍敵人造成 {10/20/30/40} 傷害。', { x: { k: 'zone', r: 150, dur: 10, dps: [10, 20, 30, 40], pal: 'ice', look: 'tornado' }, aim: P(400, 150), cd: 18 }],
    ['臥龍光線', 'bolt', '朝前方掃射 9 道光束，每道造成 {100/160/220} 傷害。', { x: { k: 'line', n: 9, fan: 0.1, gap: 0.2, dmg: [100, 160, 220], rad: 22, speed: 1100 }, aim: D(960, 70), cd: 145, shout: '臥龍光線！', el: 'holy' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    multi(u, a, X) {
      const ts = this.units.filter((o) => this.isEnemy(u, o) && !o.structure && gd(a.pt[0], a.pt[1], o.x, o.y) < (X.r || 260))
        .sort((p, q) => +(q.kind === 'hero') - +(p.kind === 'hero') || gd(a.pt[0], a.pt[1], p.x, p.y) - gd(a.pt[0], a.pt[1], q.x, q.y)).slice(0, X.n);
      if (!ts.length) { this.xRefund(u, a); return; }
      ts.forEach((t, j) => this.later(0.08 * j, () => { this.xApply(u, t, X, a); this.xFx(u, X, t.x, t.y); }));
    },
  },
});
